import { getMessages } from '../../../../../store/constants';

export const CLASS_PROMO_CODE_POPUP = 'promo-code-popup';

export const PROMO_CODE_POPUP_TEXT = getMessages().getText('promocode_popup.text');
export const PROMO_CODE_POPUP_LATER = getMessages().getText('promocode_popup.later');
export const PROMO_CODE_POPUP_PURCHASE = getMessages().getText('promocode_popup.purchase');

export const getPromoCodePopupTitle = (discount: number) => getMessages().getText('promocode_popup.title', null, discount);
